import { useWindowWidth } from '@acceso/design-system';

import { BREAKPOINT_RESPONSIVE_TABLES } from '@/constants';

type useBroadcastTableResponsiveBreakpointProps = {
  underBroadcastTableResponsiveBreakpoint: boolean;
};

export function useBroadcastTableResponsiveBreakpoint(): useBroadcastTableResponsiveBreakpointProps {
  const { width } = useWindowWidth();

  return { underBroadcastTableResponsiveBreakpoint: width <= BREAKPOINT_RESPONSIVE_TABLES };
}
